/**
 * Mapping of public Unsplash photo collections used to drive content in the
 * app.
 */
export const UNSPLASH_COLLECTIONS = {
  primary: '2742109',
  spring: '81172058',
  summer: '25786504',
  autumn: '3340319',
  winter: '64480821'
} as const;
